import request from '@/utils/shortRequest'

export default {
  rechargeGoods(params) {
    return request({
      url: '/h5/recharge/config',
      method: 'get',
      params
    })
  },
  rechargeOpenGoods(params) {
    return request({
      url: '/h5/recharge/open/config',
      method: 'get',
      params
    })
  },
  createOrder (data) {
    return request({
      url: '/h5/recharge/order/create',
      method: 'post',
      data
    })
  },
  createQrcodeOrder (data) {
    return request({
      url: '/h5/recharge/order/qrcode',
      method: 'post',
      data
    })
  },
  createOpenOrder (data) {
    return request({
      url: '/h5/recharge/open/order/create',
      method: 'post',
      data
    })
  },
  queryOrder (data, config = {}) {
    return request({
      url: '/h5/recharge/order/query',
      method: 'post',
      data,
      ...config
    })
  },
  queryOpenOrder (data, config = {}) {
    return request({
      url: '/h5/recharge/open/order/query',
      method: 'post',
      data,
      ...config
    })
  },
  checkAccount (data) {
    return request({
      url: '/h5/recharge/open/account/check',
      method: 'post',
      data
    })
  }
}
